import { NgModule } from '@angular/core';
import { FormatCoordinatesPipe } from './format-coordinates.pipe';

/**
 * Module that consolidates all custom pipes
 * Used to make pipes available throughout the application
 */
@NgModule({
  declarations: [],
  imports: [
    FormatCoordinatesPipe
  ],
  exports: [
    FormatCoordinatesPipe
  ]
})
export class PipesModule { }
